if (!customElements.get('maison-athlete-hero')) {
  customElements.define('maison-athlete-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.pointer = matchMedia('(hover: hover) and (pointer: fine)');
      this.current = { x: 0, y: 0 };
      this.target = { x: 0, y: 0 };
      this.addEventListener('pointermove', event => {
        if (this.reduced.matches || !this.pointer.matches || event.pointerType === 'touch') return;
        const rect = this.getBoundingClientRect();
        this.move(2 * ((event.clientX - rect.left) / rect.width - .5), 2 * ((event.clientY - rect.top) / rect.height - .5));
      }, options);
      this.addEventListener('pointerleave', () => this.move(0, 0), options);
      this.reduced.addEventListener('change', () => {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.current = { x: 0, y: 0 };
        this.target = { x: 0, y: 0 };
        this.style.setProperty('--mah-gaze-x', 0);
        this.style.setProperty('--mah-gaze-y', 0);
      }, options);
    }
    move(x, y) {
      if (this.reduced.matches) return;
      this.target = { x, y };
      if (this.frame) return;
      let previous = performance.now();
      const tick = now => {
        // Follow the latest pointer in one frame loop, with only a short damping tail.
        const blend = 1 - Math.exp(-Math.max(0, now - previous) / 40);
        previous = now;
        this.current.x += (this.target.x - this.current.x) * blend;
        this.current.y += (this.target.y - this.current.y) * blend;
        const settled = Math.abs(this.target.x - this.current.x) + Math.abs(this.target.y - this.current.y) < .001;
        if (settled) this.current = { ...this.target };
        this.style.setProperty('--mah-gaze-x', this.current.x.toFixed(5));
        this.style.setProperty('--mah-gaze-y', this.current.y.toFixed(5));
        this.frame = settled ? null : requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}
